import { useEffect, useRef } from "react";

const HtmlDialog = ({open,onClose,children,className}:{open:boolean,onClose:()=>void,children:React.ReactNode,className?:string}) => {
    const ref=useRef(null);
    useEffect(() => {
        const dialog = ref.current;
        if (dialog) {
            if (open) {
                (dialog as HTMLDialogElement).showModal();
            } else {
                (dialog as HTMLDialogElement).close();
            }
        }
    }, [open]);
    return (
        <dialog ref={ref} onCancel={(e)=>{onClose();e.stopPropagation()}} className={`outline-none p-0 rounded-md ${className||''}`}
        >
           {children}
        </dialog>
    );
};
export default HtmlDialog;